import { render, staticRenderFns } from "./ConfirmRemoveDayWithExtraInfo.vue?vue&type=template&id=0271619a&scoped=true"
import script from "./ConfirmRemoveDayWithExtraInfo.vue?vue&type=script&lang=js"
export * from "./ConfirmRemoveDayWithExtraInfo.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRemoveDayWithExtraInfo.vue?vue&type=style&index=0&id=0271619a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271619a",
  null
  
)

export default component.exports